import { Check, Minus } from "lucide-react";
import Reveal from "../components/Reveal";

const COLUMNS = ["LAUNCH", "GROWTH", "SIGNATURE"];

const ROWS = [
  ["Website", "yes", "yes", "yes"],
  ["Custom Design", "yes", "yes", "yes"],
  ["Story Strategy", "no", "yes", "yes"],
  ["Positioning", "no", "Guided", "Comprehensive"],
  ["Customer Journey", "no", "yes", "yes"],
  ["Business Discovery", "no", "Basic", "Deep"],
  ["Automation", "no", "Basic", "Advanced"],
  ["Custom Systems", "no", "no", "Available"],
  ["Analytics", "Basic", "Advanced", "Full Funnel"],
  ["AT Digital Role", "Builder", "Partner", "Strategic Partner"],
];

const Cell = ({ value, highlight }) => {
  if (value === "yes")
    return (
      <span className={`inline-flex h-6 w-6 items-center justify-center rounded-full ${highlight ? "bg-gold" : "bg-navy/10"}`}>
        <Check className={`h-3.5 w-3.5 ${highlight ? "text-ink" : "text-navy"}`} strokeWidth={3} />
      </span>
    );
  if (value === "no") return <Minus className="h-4 w-4 text-slate-300" />;
  return (
    <span className={`text-sm font-semibold ${highlight ? "text-white" : "text-slate-600"}`}>{value}</span>
  );
};

export default function ComparisonTable() {
  return (
    <section data-testid="comparison-section" className="bg-[#F5F7FB] pb-24 sm:pb-32">
      <div className="mx-auto max-w-5xl px-5 sm:px-8">
        <Reveal className="text-center">
          <p className="font-mono text-xs font-semibold tracking-[0.3em] text-golddeep">SIDE BY SIDE</p>
          <h2 className="mt-5 font-display text-3xl font-bold tracking-tight text-ink sm:text-4xl">
            Three levels of involvement.
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-slate-500">
            Not a small, medium and large website — three different depths of engagement.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-12 overflow-x-auto rounded-2xl border border-slate-200 bg-white shadow-xl shadow-slate-900/5">
            <table data-testid="comparison-table" className="w-full min-w-[560px] border-collapse text-left">
              <thead>
                <tr className="border-b border-slate-200">
                  <th className="px-6 py-5 font-mono text-[11px] font-semibold tracking-[0.18em] text-slate-400" />
                  {COLUMNS.map((c) => (
                    <th
                      key={c}
                      className={`px-4 py-5 text-center font-mono text-[11px] font-bold tracking-[0.18em] ${
                        c === "SIGNATURE" ? "bg-navy text-gold" : "text-ink"
                      }`}
                    >
                      {c}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {ROWS.map((row, ri) => (
                  <tr key={row[0]} className={ri % 2 === 0 ? "bg-slate-50/60" : "bg-white"}>
                    <th className="px-6 py-3.5 text-sm font-semibold text-ink">{row[0]}</th>
                    {row.slice(1).map((v, ci) => (
                      <td
                        key={ci}
                        data-testid={ri === ROWS.length - 1 ? `comparison-role-${COLUMNS[ci].toLowerCase()}` : undefined}
                        className={`px-4 py-3.5 text-center ${ci === 2 ? "bg-navy text-slate-200" : ""}`}
                      >
                        <Cell value={v} highlight={ci === 2} />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
